<template>
    <label
        class="comboParlayOptionCard"
        v-bind:class="{ _selected: modelValue }"
        v-on:click.prevent="toggleSelection"
    >
        <input
            class="comboParlayOptionCard-checkbox"
            type="checkbox"
            v-bind:checked="modelValue"
            v-bind:disabled="disabled"
            v-on:click.stop="toggleSelection"
        >
        <span class="comboParlayOptionCard-info">
            <strong class="comboParlayOptionCard-name">
                {{ name }}
            </strong>
            <SboIcon
                v-if="canCashOut"
                class="comboParlayOptionCard-cashOut"
                name="system:cashOut"
                data-testid="combo-parlay-cash-out"
            />
            <span
                v-if="odds"
                class="comboParlayOptionCard-odds"
            >
                @{{ odds }}
            </span>
        </span>
        <span class="comboParlayOptionCard-payout">
            <span class="comboParlayOptionCard-payoutLabel">{{ i18n.t('maxPayout') }}</span>
            <strong class="comboParlayOptionCard-payoutValue">
                {{ payout }}
            </strong>
        </span>
    </label>
</template>

<script setup lang="ts">
    import SboIcon from '@/components/common/SboIcon.vue';
    import { i18n } from '@/libraries/i18n';

    const props = defineProps<{
        name: string;
        odds?: string;
        payout: string;
        disabled: boolean;
        canCashOut?: boolean;
    }>();

    const modelValue = defineModel<boolean>({ default: false });

    function toggleSelection() {
        if (props.disabled) {
            return;
        }
        modelValue.value = !modelValue.value;
    }
</script>

<style lang="scss" scoped>
@import "@/scss/components/singleMode/comboParlayOptionCard";
</style>
